module.exports = __webpack_public_path__ + "../resources/images/letsgo-cloud-east-8bbb45b51a0d204f1655b8e2ec4c2b09.png";